import { render, staticRenderFns } from "./addProductionCompany.vue?vue&type=template&id=69228b0c&"
import script from "./addProductionCompany.vue?vue&type=script&lang=js&"
export * from "./addProductionCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports